<template>
  <v-col>
    <v-btn
      class="ma-2"
      color="info"
      @click="takeBackup"
    >
      Backup now
    </v-btn>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">
              #
            </th>
            <th class="text-left">
              Time
            </th>
            <th class="text-left">
              File Name
            </th>
            <th class="text-left">
              File size
            </th>
            <th class="text-left">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(backup, key) in backups"
            :key="backup.time"
          >
            <td>{{ key + 1 }}</td>
            <td>{{ backup.time }}</td>
            <td>{{ backup.name }}</td>
            <td>{{ backup.size }}</td>
            <td>
              <v-btn
                class="ma-2"
                color="info"
                @click="restoreBackup(backup.name)"
              >
                Restore
              </v-btn>
              <v-btn
                class="ma-2"
                color="error"
                @click="removeBackup(backup)"
              >
                Remove
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-col>
</template>
<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      backups: [],
    };
  },
  mounted() {
    this.loadBackup();
  },
  methods: {
    ...mapActions({
      snackbar: "snackbar/show",
    }),
    loadBackup() {
      window.axios.get("/backup-load").then((response) => {
        this.backups = response.data.backups;
      });
    },
    removeBackup(file) {
      if (confirm("Are you sure to remove ?")) {
        const index = this.backups.indexOf(file);
        window.axios
          .post("/backup-remove", { file: file.name })
          .then((response) => {
            this.backups.splice(index, 1);
            this.snackbar(response.data.message);
          });
      }
    },
    restoreBackup(file) {
      if (confirm("Are you sure to restore backup ? ")) {
        window.axios.patch("/backup-restore", { file }).then((response) => {
          this.snackbar(response.data.message);
        });
      }
    },
    takeBackup() {
      window.axios.post("/backup-generate").then((response) => {
        this.snackbar(response.data.message);
        this.loadBackup();
      });
    },
  },
};
</script>
